import React, { PropTypes } from 'react';
import { Link } from 'react-router';
import PeopleListItem from './PeopleListItem';
import { contentTypes } from '../../langMap';

const PeopleList = ({ people, type, edition, lang }) => {
  if (typeof people === 'undefined' || people.length === 0) {
    return null;
  }
  const doYouHaveALinkOrNot = (id, link, slug, rest, isLast) => {
    const style = {
      color: edition.background,
    };
    switch (type) {
      case 'facilitators':
        return (
          <li key={id} className="slash-separated__list__item">
            <Link style={style} to={lang === 'ar' ? `/ar${slug}?${edition.id}` : `${slug}?${edition.id}`}>{rest.title}</Link>
            {isLast ? '.' : ' /'}
          </li>
        );
      default:
        return link ?
          (
            <li key={id} className="slash-separated__list__item">
              <a style={style} href={link} target="_blank" rel="noopener noreferrer">
                {rest.title}
              </a>
              {isLast ? '.' : ' /'}
            </li>
          ) :
            <PeopleListItem key={id} {...rest} type={type} isLast={isLast} />;
    }
  };
  return (
    <section className="subsection">
      <header className="subsection__header">
        {
          lang === 'ar' ?
            <h2 className="subsection__header__title">{contentTypes[type]}</h2> :
            <h2 className="subsection__header__title">{type}</h2>
        }
      </header>
      <ul className="slash-separated__list">
        {
          people.map(({ ...rest, id, link, slug }, index) => {
            const isLast = index === people.length - 1;
            return doYouHaveALinkOrNot(id, link, slug, { ...rest }, isLast);
          })
        }
      </ul>
    </section>
  );
};

PeopleList.propTypes = {
  lang: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  people: PropTypes.arrayOf(PropTypes.object),
  edition: PropTypes.shape({
    id: PropTypes.string,
  }).isRequired,
};

PeopleList.defaultProps = {
  people: undefined,
};

export default PeopleList;



// WEBPACK FOOTER //
// ./js/components/people/PeopleList.js